import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EntityContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
  BasicApiResponseModel
} from '../../shared';
import { EntityQueryCriteriaClass, EntityCriteriaModelQuery } from '../../../criteria/entity-criteria.model';


@Injectable({
  providedIn: 'root'
})
export class CustomerService extends BaseApiTemplateService<EntityContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/customers';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/customers';
    this.httpClient = http;
  }

  getCustomerByCriteria(visa: ApiVisa, criteria?: EntityQueryCriteriaClass):
    Observable<PagingResponseModel<any>> {
    const buildEntityCriteriaCriteria = new EntityCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<any>>(this.apiUrl + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }

  public createTemp(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url;
    }
    return this.httpClient.post<BasicApiResponseModel<EntityContainerModel>>(
      this.apiUrl + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/temp/customers/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  getCustByCriteria(
    visa: ApiVisa, criteria?: EntityQueryCriteriaClass
  ): Observable<PagingResponseModel<EntityContainerModel>> {
    const buildDocCriteria = new EntityCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<PagingResponseModel<EntityContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa));
  }

  getOwnCustomer(apiVisa: ApiVisa): Observable<ApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/own';
    }
    return this.httpClient.get<ApiResponseModel<EntityContainerModel>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }
}
